import WFHelper from './WFHelper'

const uuidv4 = require('uuid/v4')

/**
 * Created by Xuz on 2020/02/02.
 * xuz@live.cn
 *
 * 工作流标题及总体定义控制类
 */
class WFObject {
  constructor (workflow) {
    this.workflow = workflow
    this.sUuid = uuidv4()
    this.dSvg = null
    this.dContainer = null
    this.dText = null
    this.sAttrName = null
    this.bSrc = false
  }

  isSrc () {
    return this.bSrc
  }

  uuid () {
    return this.sUuid
  }

  getName () {
    return this.sAttrName
  }

  setName (name) {
    this.sAttrName = name
    this.dText.tspan(this.sAttrName)
  }

  remove () {
  }

  create () {
    const oSvgJs = this.workflow.getSvgJs()

    this.dSvg = oSvgJs.group()
    let trans = 'translate(50,10)'
    this.dSvg.attr('transform', trans)
    this.serial()

    this.dContainer = oSvgJs.rect()

    this.dContainer.attr('width', 100)
    this.dContainer.attr('height', 20)
    this.dContainer.attr('fill', 'white')
    this.dContainer.attr('stroke', 'gray')
    this.dContainer.attr('stroke-width', '1')
    this.dContainer.attr('uuid', this.sUuid)
    this.dContainer.attr('x', 0)
    this.dContainer.attr('y', 0)
    this.dSvg.add(this.dContainer)

    this.sAttrName = WFHelper.getWorkFlowName()
    this.dText = oSvgJs.text('')
    this.dText.attr('uuid', this.sUuid)
    this.dText.attr('x', 5)
    this.dText.attr('y', 15)
    this.dText.tspan(this.sAttrName)

    this.dSvg.add(this.dText)

    const that = this
    this.dSvg.mousedown(event => that.workflow.onMouseDown(event))

    oSvgJs.add(this.dSvg)

    this.fixLayout()

    this.workflow.registerElement(this)
  }

  serial () {
    this.dSvg.attr('uuid', this.sUuid)
    this.dSvg.attr('wf-class', 'WFObject')
  }

  /**
   * 修正外观，主要是描述改变时其包围框的大小
   */
  fixLayout () {
    const textRect = WFHelper.getRect(this.dText)
    this.dContainer.attr('width', textRect.width + 15)
  }

  getXmlNode (dXml) {
    let node = dXml.createElement('define')
    node.setAttribute('name', this.sAttrName)
    node.setAttribute('uuid', this.sUuid)
    return node
  }

  updateXmlNode () {
    const wfXml = this.workflow.getWfXml()
    let node = wfXml.getNode(this.sUuid)
    node.setAttribute('name', this.sAttrName)
  }

  setWFAttributes (attrName, value) {
    const wfXml = this.workflow.getWfXml()
    if (attrName === 'FORM') {
      const oXml = wfXml.getXml()
      let nodes = WFHelper.createWFFormAttributesNode(value, oXml)
      let node = wfXml.getNode(this.sUuid)
      WFHelper.removeWFFormAttributes(node)
      for (let i = 0; i < nodes.length; i++) {
        node.appendChild(nodes[i])
      }
    }

    if (attrName === 'COMMENTS') {
      wfXml.setComments(value)
    }

    // TODO 缺少操作
  }

  pushWFAttributes (formData) {
    const wfXml = this.workflow.getWfXml()
    WFHelper.pushWFFormAttributes(formData, wfXml.getNode(this.sUuid))
  }

  onSelect () {
    this.dContainer.attr('stroke', 'black')
  }

  onUnSelect () {
    this.dContainer.attr('stroke', 'gray')
  }

  onMouseDblClick () {
    let parent = this.workflow.getParent()
    parent.onEditObjectNode(this)
  }

  onMove () {
  }

  onUp () {
  }

  onToolbarChange () {
  }

  unSerial (svg) {
    this.bSrc = true
    this.dSvg = svg
    this.sUuid = this.dSvg.attr('uuid')
    let children = this.dSvg.children()
    this.dContainer = children[0]
    this.dText = children[1]
    this.sAttrName = this.dText.text()

    this.workflow.registerElement(this)

    this.workflow.setWFObject(this)
  }
}

export default WFObject
